import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './Header.css';

const Header: React.FC = () => {
  const { user, signOut, clearError } = useAuth();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSigningOut, setIsSigningOut] = useState(false);

  const handleSignOut = async () => {
    if (isSigningOut) return;
    
    setIsSigningOut(true);
    try {
      clearError();
      await signOut();
      navigate('/login');
    } catch (error) {
      console.error('Error signing out:', error);
      // Even if sign out fails, redirect to login
      navigate('/login');
    } finally {
      setIsSigningOut(false);
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="header-logo" onClick={closeMenu}>
          <span className="logo-icon">🎒</span>
          <span className="logo-text">Simple Packing</span>
        </Link>

        <nav className={`header-nav ${isMenuOpen ? 'nav-open' : ''}`}>
          <Link to="/dashboard" className="nav-link" onClick={closeMenu}>
            Dashboard
          </Link>
          <Link to="/gear" className="nav-link" onClick={closeMenu}>
            Gear
          </Link>
          <Link to="/templates" className="nav-link" onClick={closeMenu}>
            Templates
          </Link>
          <Link to="/trips" className="nav-link" onClick={closeMenu}>
            Trips
          </Link>

          <div className="user-menu">
            <span className="user-name">{user?.name || user?.email}</span>
            <button
              onClick={handleSignOut}
              className="sign-out-btn"
              disabled={isSigningOut}
            >
              {isSigningOut ? 'Signing Out...' : 'Sign Out'}
            </button>
          </div>
        </nav>

        <div className="header-actions">
          <button
            className="mobile-menu-btn"
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span className={`hamburger ${isMenuOpen ? 'active' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;